import { useCallback, useEffect, useRef, useState } from "react";

export default function useSubscriptionRefresh() {
  const [revision, setRevision] = useState(0);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
  const lastRefresh = useRef(0);
  const refresh = useCallback(() => {
    lastRefresh.current = Date.now();
    setRevision((value) => value + 1);
  }, []);
  useEffect(() => {
    const visibleRefresh = () => {
      if (document.visibilityState === "visible" && Date.now() - lastRefresh.current > 2000) refresh();
    };
    const interval = window.setInterval(visibleRefresh, 60000);
    window.addEventListener("focus", visibleRefresh);
    document.addEventListener("visibilitychange", visibleRefresh);
    return () => {
      window.clearInterval(interval);
      window.removeEventListener("focus", visibleRefresh);
      document.removeEventListener("visibilitychange", visibleRefresh);
    };
  }, [refresh]);
  return { revision, refresh, lastUpdated, setLastUpdated };
}
